import {
  MenuItemProps,
  useTranslationLang,
  useTranslationRoute,
  useTranslations,
} from "@harea/component";
import { BanknoteIcon, GiftIcon, Clock, HandCoins, Handshake, ReceiptText } from "lucide-react";
import { useMemo } from "react";

export const useLeftSideBarMenuPayslip = () => {

  const [AVANCE, PAIE, OVERTIME_RATE, LOAN, UNION_DUES, INDEMNITIES, PAYBACK, PRIME, CALCULATION] = useTranslations(i18n);
  const { lang } = useTranslationLang();
  const translationRoute = useTranslationRoute();

  return useMemo(
    (): MenuItemProps => ({
      ke: "payslip",
      label: PAIE,
      className: "menu-item-category",

      items: [
        {
          key: "primes",
          label: PRIME,
          startIcon: <GiftIcon />,
          link: translationRoute("admin/primes"),
          className: "menu-item-category",
        },
        {
          key: "indemnities",
          label: INDEMNITIES,
          startIcon: <GiftIcon />,
          link: translationRoute("admin/indemnities"),
          className: "menu-item-category",
        },
        {
          key: "paybacks",
          label: PAYBACK,
          startIcon: <ReceiptText />,
          link: translationRoute("admin/paybacks"),
          className: "menu-item-category",
        },
        {
          key: "avance",
          label: AVANCE,
          startIcon: <GiftIcon />,
          link: translationRoute("admin/avance"),
          className: "menu-item-category",
        },
        {
          key: "loan",
          label: LOAN,
          startIcon: <HandCoins />,
          link: translationRoute("admin/loans"),
          className: "menu-item-category",
        },
        {
          key: "cotisation-syndicale",
          label: UNION_DUES,
          startIcon: <Handshake />,
          link: translationRoute("admin/cotisation-syndicale"),
          className: "menu-item-category",
        },
        {
          key: "overtime-rate",
          label: OVERTIME_RATE,
          startIcon: <Clock />,
          link: translationRoute("admin/overtime-rate"),
          className: "menu-item-category",
          roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
        },

        {
          key: "payroll",
          label: CALCULATION,
          startIcon: <BanknoteIcon />,
          link: translationRoute("admin/payrolls"),
          className: "menu-item-category",
        },
      ],

      // roles: ["DASHBOARD_ADMIN_RH"],
    }),
    [lang],
  );
};

const i18n = [
  "std_avance",
  "std_payroll",
  "std_overtime_rate_title",
  "BSMRH.Loan.Title",
  "Harea.Payroll.SyndicalCotisation.Title",
  "std_indemnities",
  "std_payback",
  "std_prime",
  "std_calculation",
];


